export enum FiContentLanguageLabelObjectType {
    AreaNames = 1,
    AreaDescriptions = 2,
    BusinessAreaNames = 3,
    BusinessAreaDescriptions = 4,
    RoleNames = 5,
    RoleDescriptions = 6,
    ClusterNames = 7,
    ClusterDescriptions = 8,
    TagNames = 9,
    TagDescriptions = 10,
    ExtendedRoleRightNames = 11,
    ExtendedRoleRightDescriptions = 12,
    DocumentNames = 13,
    DocumentDescriptions = 14,
    TemplateNames = 15,
    TemplateDescriptions = 16,
    WidgetModuleNames = 17,
    TemplateControlContent = 18,
    ContentLanguageNames = 19,
    DocumentControlContent = 23,
    AgreementNames = 24,
    AgreementDescriptions = 25,
}
